import SidebarChannels from './SidebarChannels'

export default SidebarChannels
